/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-20T16:51:35.227
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialPayApplyItem,
	listFinancialPayApplyItemInit,
	listFinancialPayApplyItemByAuthorizations,
	deleteFinancialPayApplyItem
} from '@api/rentmanage/FinancialPayApplyItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialPayApplyItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayApplyItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPayApplyItemByAuthorizations({state}) {
			return new Promise((resolve, reject) => {
				listFinancialPayApplyItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPayApplyItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayApplyItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPayApplyItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPayApplyItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
